// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__293oH","icon":"search_icon__vM6AO","input":"search_input__11foT","button":"search_button__144sl"};